import { Control, useFieldArray, UseFormRegister, useWatch } from 'react-hook-form'

import { FormQuestion } from '../modalsQuestion/QuestionAddEdit'

interface TypeUniqueProps {
    control: Control<FormQuestion, any> | undefined
    register: UseFormRegister<FormQuestion>
    isLoading: boolean
}

export const TypeMultiple = ({ control, register, isLoading }: TypeUniqueProps) => {
    const { fields, append, remove, replace } = useFieldArray({
        control,
        name: 'alternatives',
    })

    const alternatives = useWatch({
        control,
        name: 'alternatives',
    })

    const addNewAlternative = () => append({ correct: false, value: '' })

    const onRemoveAlternative = (index: number) => () => remove(index)

    const onSetAnswer = (index: number) => () => {
        const newFields = alternatives.map((alternative, idx) => ({
            ...alternative,
            correct: idx === index ? !alternative.correct : alternative.correct,
        }))
        replace(newFields)
    }

    return (
        <div className="alternatives_content">
            {fields.length ? (
                fields.map((field, index) => (
                    <div key={field.id} className="alternatives_item">
                        <div>
                            <input
                                className="input_question"
                                placeholder="Escribe aqui..."
                                autoFocus={true}
                                required
                                disabled={isLoading}
                                {...register(`alternatives.${index}.value` as const)}
                            />
                            <button
                                type="button"
                                onClick={onRemoveAlternative(index)}
                                disabled={isLoading}
                            >
                                <i className="fa fa-trash" />
                            </button>
                        </div>
                        <div className="pointer">
                            <input
                                id={field.id}
                                type="checkbox"
                                checked={field.correct}
                                onChange={onSetAnswer(index)}
                                disabled={isLoading}
                            />
                            <label
                                htmlFor={field.id}
                                style={{
                                    fontWeight: 'normal',
                                    margin: 0,
                                    cursor: 'pointer',
                                }}
                            >
                                Marcar como opción correcta
                            </label>
                        </div>
                    </div>
                ))
            ) : (
                <div className="alternatives_message">
                    <h4>Aún no hay alternativas</h4>
                </div>
            )}

            <div className="alternatives_buttons">
                <button type="button" onClick={addNewAlternative} disabled={isLoading}>
                    <span className="fas fa-plus"></span> Agregar Alternativa
                </button>
            </div>
        </div>
    )
}
